import FoodListContainer from '../../../../Componant/Application/Ecommerce/master/FoodListContainer'

const FoodList = () => {
  return (
    <div className='page-body'>
      <FoodListContainer />
    </div>
  )
}

export default FoodList